import React from "react";
import { Card, Typography } from "@mui/material";
import { browsers } from "../../../../constants";

const SelectBrowser = ({ selectedBrowsers, setSelectedBrowsers }) => {

  const handleBrowserToggle = (browser) => {
    setSelectedBrowsers((prev) => {
      const exists = prev.some((b) => b.id === browser.id);
      return exists ? prev.filter((b) => b.id !== browser.id) : [...prev, browser];
    });
  };

  return (
    <Card className="browser-card">
      <Typography variant="h6" className="section-title">
        Select Browser
      </Typography>
      <div className="browser-icons">
        {browsers.map((browser) => (
          <div
            key={browser.id}
            className={`browser-icon-wrapper ${
              selectedBrowsers.some((b) => b.id === browser.id) ? "selected" : ""
            }`}
            onClick={() => handleBrowserToggle(browser)}
          >
            <div className="browser-icon-inner">
              <img src={browser.icon} alt={browser.id} />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default SelectBrowser;
